import styled from 'styled-components';
import {
  mobile_width_percentage,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const LocationsStateListingStyles = styled.div`
  background-color: ${Colors.accent.grey7.standard};
  padding: 20px 0 30px 0;

  .locations-state-listing-inside {
    margin: 0 auto;
    width: ${mobile_width_percentage}%;
  }
  .no-home-centers {
    text-align: center;
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    padding-top: 30px;
  }
`;

export default LocationsStateListingStyles;
